export const leadCategories = [
  { slug: "consumer", name: "消费维权", desc: "预付卡跑路、货不对板、退款无门、售后推诿。", icon: "ri-shopping-bag-3-line" },
  { slug: "workplace", name: "职场内幕", desc: "加班文化、合同陷阱、绩效克扣、离职纠纷。", icon: "ri-briefcase-4-line" },
  { slug: "industry", name: "行业观察", desc: "报价内幕、补贴流向、渠道猫腻、灰色规则。", icon: "ri-line-chart-line" },
  { slug: "livelihood", name: "民生身边事", desc: "社区治理、公共收费、设施改造、身边困扰。", icon: "ri-home-smile-2-line" },
  { slug: "internet", name: "网络乱象", desc: "虚假宣传、话术套路、流量造假、诱导付费。", icon: "ri-signal-tower-line" },
  { slug: "charity", name: "公益求助", desc: "捐赠去向、帮扶争议、志愿项目中的疑点。", icon: "ri-heart-3-line" },
];

export const leads = [
  {
    id: "community-group-buy-refund",
    title: "社区团购“低价”背后的退款陷阱：两百户居民等了三个月",
    category: "消费维权",
    categorySlug: "consumer",
    summary:
      "同一款纸巾，团购价比超市贵两成，退款却要排到三个月后。多位居民向我们提供了订单截图与客服话术记录。",
    author: "直曝编辑部",
    date: "2026-08-28",
    readTime: "7 分钟",
    views: 4821,
    tags: ["社区团购", "退款难", "预付消费"],
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20still%20life%20of%20stacked%20plain%20cardboard%20delivery%20boxes%20with%20muted%20vermillion%20red%20paper%20labels%20on%20warm%20cream%20backdrop%2C%20soft%20studio%20light%2C%20minimal%20serious%20magazine%20art%20direction%2C%20subtle%20film%20grain%2C%20no%20text%2C%20high%20detail&width=800&height=560&seq=lead-grocery-refund-01&orientation=landscape",
    content: [
      {
        heading: "一条来自业主群的线索",
        paragraphs: [
          "八月中旬，我们收到一位署名“老周”的读者投稿。他所在的住宅小区从今年年初开始流行社区团购，团长是小区里一位热心的邻居，群里最多时有四百多人。",
          "“一开始确实便宜，后来价格悄悄涨了，但大家图方便还是接着买。”老周提供的三十多张订单截图显示，同一款抽纸在团购价上比附近超市的促销价高出接近两成。",
        ],
      },
      {
        heading: "退款按钮背后的排期表",
        paragraphs: [
          "问题出在退款环节。多位居民反映，提交退款申请后，页面只显示“退款将按顺序处理”，没有具体时间。有人从五月等到八月，仍未收到款项。",
          "我们拿到了团长与供货方客服的对话记录。客服给出的说法是“资金在供应链，需要逐笔核销”，并多次要求团长“先安抚群内情绪”。",
        ],
      },
      {
        heading: "三个值得追问的问题",
        paragraphs: [
          "第一，团购资金是否进入了第三方存管？如果没有，居民的钱实际上流向了哪里？",
          "第二，团长作为个人，在其中承担什么责任？目前多数团长只是普通居民，既不掌握资金，也无法核查库存。",
          "第三，退款排期的规则由谁制定、是否对外公示？在现有记录中，我们没有看到任何书面说明。",
        ],
      },
      {
        heading: "编辑说明",
        paragraphs: [
          "本文基于投稿人提供的订单截图、聊天记录整理，涉及的具体企业名称已在核实前隐去。我们已就上述疑点向相关平台发出问询，截至发稿未获正式回复，如有进展将持续更新。",
        ],
      },
    ],
  },
  {
    id: "overtime-volunteer-letter",
    title: "我被要求签下“自愿加班”承诺书的那个月",
    category: "职场内幕",
    categorySlug: "workplace",
    summary:
      "入职第三周，工位上来了一张空白承诺书。签或不签，部门群里没人敢先开口。一位读者完整还原了这段经历。",
    author: "直曝编辑部",
    date: "2026-08-21",
    readTime: "6 分钟",
    views: 6390,
    tags: ["加班文化", "劳动合同", "职场"],
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20photograph%20of%20a%20blank%20white%20document%20sheet%20on%20a%20dark%20wooden%20desk%20corner%20with%20single%20amber%20desk%20lamp%20glow%2C%20moody%20minimal%20composition%2C%20warm%20neutral%20tones%2C%20no%20text%2C%20subtle%20grain%2C%20serious%20magazine%20art%20direction%2C%20high%20detail&width=800&height=560&seq=lead-overtime-letter-02&orientation=landscape",
    content: [
      {
        heading: "一张没有落款的纸",
        paragraphs: [
          "投稿人小黎（化名）今年三月入职一家中型服务公司。她说，第三周的周一早上，每个人工位上都放着一张 A4 纸，只有一句话和一条签名线。",
          "“大意是本人自愿申请延长工作时间，与考勤、绩效无关。”小黎说，没有人解释这张纸的用途，也没有人说不签会怎样。",
        ],
      },
      {
        heading: "群里的沉默",
        paragraphs: [
          "当天中午，部门群里陆续有人发出已签字的照片。小黎犹豫到下班，最终也签了。“不是没想过问，但第一个开口的人，代价太大了。”",
          "我们咨询的劳动法领域从业者表示，这类承诺书本身不能免除用人单位依法支付加班报酬的义务，但它在实际争议中确实会被用来制造“举证困难”。",
        ],
      },
      {
        heading: "比一张纸更需要被记录的",
        paragraphs: [
          "真正让小黎决定投稿的，是随后的两个多月。她的打卡记录显示，平均每个工作日实际在岗时间超过十小时，而系统里的加班时长长期为零。",
          "类似的现象并不罕见。如果你手上有考勤截图、排班表、群通知等材料，欢迎通过我们的投稿通道提交，我们会对来源做匿名处理。",
        ],
      },
    ],
  },
  {
    id: "short-video-training-script",
    title: "短视频培训机构的“包就业”话术拆解",
    category: "网络乱象",
    categorySlug: "internet",
    summary:
      "一份流传在销售群里的“转化脚本”，把学员的犹豫、提问、退款都写成了对应台词。我们逐句做了还原。",
    author: "内容核查组",
    date: "2026-08-14",
    readTime: "8 分钟",
    views: 7120,
    tags: ["虚假宣传", "培训贷", "话术"],
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20concept%20image%20of%20layered%20translucent%20paper%20cards%20floating%20with%20soft%20vermillion%20and%20amber%20light%20edges%20over%20cream%20background%2C%20minimal%20geometric%20composition%2C%20no%20text%2C%20fine%20grain%2C%20serious%20investigative%20magazine%20style%2C%20high%20detail&width=800&height=560&seq=lead-script-breakdown-03&orientation=landscape",
    content: [
      {
        heading: "脚本从哪里来",
        paragraphs: [
          "一位曾在某短视频培训机构做了四个月电话销售的读者，把内部培训资料交给了我们。文件是一份二十多页的 Word，标题写着“异议处理标准话术”。",
          "所谓“异议处理”，就是当学员说“太贵了”“怕学不会”“想再考虑”时，销售应该怎么接。每一句都被写好了。",
        ],
      },
      {
        heading: "三段最典型的话术",
        paragraphs: [
          "当学员说“我没有基础”时，脚本要求回答“我们收的本来就是零基础，有基础的人我们还不一定收”。",
          "当学员说“先交定金可以吗”时，脚本写明“要一次性付清才算锁定名额，分期的话名额不保留”。",
          "当学员问“真的能包就业吗”时，脚本回避直接承诺，改说“往期学员就业率百分之九十几”，但不提供可核验的样本。",
        ],
      },
      {
        heading: "为什么“包就业”很难兑现",
        paragraphs: [
          "从我们接触到的合同样本看，多数机构的“就业推荐”条款都会附加一句“不保证入职”，或者把“就业”定义成一次岗位推荐。",
          "这意味着，销售口头的承诺与合同的文字之间存在一道缝隙。如果你正被类似话术围着，请保留完整的聊天记录，它可以成为最直接的证据。",
        ],
      },
    ],
  },
  {
    id: "old-community-elevator-signature",
    title: "老旧小区加装电梯：意见征集表上的签名从哪来",
    category: "民生身边事",
    categorySlug: "livelihood",
    summary:
      "一份“同意率超过九成”的征集表，被居民发现有三个签名笔迹几乎完全相同。社区随后暂停了公示流程。",
    author: "直曝编辑部",
    date: "2026-08-07",
    readTime: "6 分钟",
    views: 3980,
    tags: ["老旧小区", "公共事务", "程序公开"],
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20image%20of%20a%20stack%20of%20signed%20paper%20forms%20on%20a%20concrete%20stairwell%20ledge%20with%20soft%20morning%20light%2C%20warm%20neutral%20palette%20with%20faint%20red%20accent%2C%20minimal%20serious%20documentary%20mood%2C%20no%20readable%20text%2C%20subtle%20grain%2C%20high%20detail&width=800&height=560&seq=lead-elevator-sign-04&orientation=landscape",
    content: [
      {
        heading: "一张贴在单元门口的表格",
        paragraphs: [
          "六月底，某市一处建成二十余年的居民楼贴出了加装电梯的意见征集结果。表格上写着同意户数占总户数的九成以上。",
          "住在二楼的投稿人多看了几眼，发现其中几个签名不仅用词接近，连笔势的倾斜角度都几乎一致。",
        ],
      },
      {
        heading: "被暂停的公示",
        paragraphs: [
          "他把疑问发到了业主群，随后有邻居逐户核对，发现至少有五户表示从未签署过这份表格。一周后，社区公告称“因部分信息需复核，公示暂停”。",
          "“我们不是反对装电梯。”投稿人强调，“我们想知道，那张表上到底有多少是真的。”",
        ],
      },
      {
        heading: "这类线索的价值",
        paragraphs: [
          "公共事务中的程序问题，往往就藏在一张表格、一次公示、一个签名里。它们单看很小，但直接关系到每个住户的权益。",
          "如果你所在的小区也遇到类似情况，建议先保存原始表格的照片，再通过投稿通道提交，注明时间与楼栋即可，无需提供个人身份信息。",
        ],
      },
    ],
  },
  {
    id: "fitness-card-before-closure",
    title: "连锁健身房闭店前一周，仍在推销三年卡",
    category: "消费维权",
    categorySlug: "consumer",
    summary:
      "门店关闭前七天，销售仍在电话里承诺“明年一定开新店”。三位会员提供了完整的推销录音时间线。",
    author: "直曝编辑部",
    date: "2026-07-30",
    readTime: "5 分钟",
    views: 5540,
    tags: ["预付卡", "健身", "关门跑路"],
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20scene%20of%20an%20empty%20gym%20with%20covered%20equipment%20and%20dim%20warm%20lighting%20through%20tall%20windows%2C%20muted%20brown%20and%20soft%20red%20tones%2C%20quiet%20melancholy%20mood%2C%20minimal%20composition%2C%20no%20text%2C%20cinematic%20grain%2C%20high%20detail&width=800&height=560&seq=lead-fitness-card-05&orientation=landscape",
    content: [
      {
        heading: "最后一次续卡",
        paragraphs: [
          "会员林女士在闭店前一周接到销售电话，对方称门店即将升级，续三年卡“锁定现价”。她当天通过转账支付了两万余元。",
          "七天后，门店贴出通知，称“因经营调整暂停营业”。",
        ],
      },
      {
        heading: "时间线上的矛盾",
        paragraphs: [
          "我们把三位会员的通话记录按时间排列，发现闭店前三天，销售仍在群里发布“新店选址已定”的消息。这条消息与公司内部的停业安排显然对不上。",
          "投稿人提供的转账凭证、聊天记录与门店通知，我们已经交叉核对过时间点。",
        ],
      },
      {
        heading: "给还在犹豫的人",
        paragraphs: [
          "预付类消费的风险，几乎都集中在“闭店前的最后一段推销”。如果一家店的优惠突然变得异常慷慨，这本身就是需要留意的信号。",
          "保留付款凭证和宣传截图，是后续维权最基础的两样东西。",
        ],
      },
    ],
  },
  {
    id: "industry-two-quotations",
    title: "同一批货，两种报价：补贴究竟流向了哪里",
    category: "行业观察",
    categorySlug: "industry",
    summary:
      "上游报价单与下游结算单存在稳定差额，中间经过三层主体。一位从业者把两套单据一并寄给了我们。",
    author: "内容核查组",
    date: "2026-07-22",
    readTime: "9 分钟",
    views: 4260,
    tags: ["供应链", "报价", "补贴"],
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20flat%20lay%20of%20printed%20spreadsheet%20sheets%20and%20a%20calculator%20on%20a%20warm%20cream%20desk%2C%20muted%20vermillion%20and%20amber%20highlights%2C%20minimal%20serious%20business%20documentary%20style%2C%20no%20readable%20text%2C%20subtle%20paper%20grain%2C%20high%20detail&width=800&height=560&seq=lead-price-docs-06&orientation=landscape",
    content: [
      {
        heading: "两套单据",
        paragraphs: [
          "投稿人从事的是一类标准化产品的区域分销。他提供的上游报价单显示，单价长期稳定；而下游结算单上的价格，在同一时间段内高出一截。",
          "差额并没有留在他的账上，而是通过两家中间主体走账。",
        ],
      },
      {
        heading: "三层主体之间",
        paragraphs: [
          "我们把三份主体信息并列，发现其中两家注册地址相同，成立时间相差不到两周。",
          "这类结构在供应链中并不罕见，但如果它与公开补贴的申报口径重叠，就值得进一步核实。我们已就此向相关方面发出问询。",
        ],
      },
      {
        heading: "核查中的难点",
        paragraphs: [
          "行业类线索的难点在于，单据之间往往能自洽，需要外部信息才能印证。这也是我们格外希望从业者提供完整链条材料的原因。",
        ],
      },
    ],
  },
  {
    id: "medical-beauty-lecturer-list",
    title: "医美广告里的“专家”是谁？一份讲师名单的流向",
    category: "网络乱象",
    categorySlug: "internet",
    summary:
      "同一张脸，出现在五个不同机构的宣传页上，头衔却各不相同。我们顺着名单找到了源头。",
    author: "内容核查组",
    date: "2026-07-15",
    readTime: "7 分钟",
    views: 6015,
    tags: ["医美", "广告", "资质"],
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20image%20of%20several%20blank%20profile%20photo%20frames%20arranged%20in%20a%20grid%20on%20a%20muted%20cream%20wall%20with%20soft%20shadow%2C%20faint%20vermillion%20accents%2C%20minimal%20conceptual%20composition%2C%20no%20readable%20text%2C%20subtle%20grain%2C%20high%20detail&width=800&height=560&seq=lead-beauty-list-07&orientation=landscape",
    content: [
      {
        heading: "五张宣传页，一个名字",
        paragraphs: [
          "读者小陈在做功课的时候，把几家机构的宣传页截图放在一起对比，发现其中一位“首席专家”的面孔反复出现，但头衔写法完全不同。",
          "她把这些截图投给了我们。",
        ],
      },
      {
        heading: "名单的源头",
        paragraphs: [
          "顺着图片水印与素材站的授权信息，我们找到了一份公开售卖的“讲师形象素材包”，其中包含照片、可替换的简介模板和使用说明。",
          "也就是说，这些宣传页上的“专家”，可能只是买来的图片。",
        ],
      },
      {
        heading: "如何自己判断",
        paragraphs: [
          "一个简单的办法：把宣传页上的姓名、头衔、照片分别搜索一遍。如果三者无法指向同一个人，就值得多留一个心眼。",
        ],
      },
    ],
  },
  {
    id: "donation-goods-resale",
    title: "爱心捐赠物资被转卖的疑点与追问",
    category: "公益求助",
    categorySlug: "charity",
    summary:
      "一批贴着爱心标签的衣物，出现在二手交易平台上。捐赠者认出了自己缝在袖口的名字。",
    author: "直曝编辑部",
    date: "2026-07-06",
    readTime: "6 分钟",
    views: 3450,
    tags: ["公益", "捐赠", "物资去向"],
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20still%20life%20of%20neatly%20folded%20secondhand%20clothes%20and%20plain%20cartons%20in%20a%20soft%20warm%20lit%20storage%20space%2C%20muted%20olive%20and%20cream%20palette%20with%20faint%20red%20tag%20accents%2C%20quiet%20documentary%20mood%2C%20no%20readable%20text%2C%20fine%20grain%2C%20high%20detail&width=800&height=560&seq=lead-donation-resale-08&orientation=landscape",
    content: [
      {
        heading: "袖口上的名字",
        paragraphs: [
          "投稿人去年冬天整理了两箱衣物，通过小区组织的活动捐出。其中一件外套的袖口内侧，她习惯性地缝了一个名字缩写。",
          "今年春天，她在二手平台上刷到了这件外套。",
        ],
      },
      {
        heading: "中间发生了什么",
        paragraphs: [
          "从平台上的卖家信息看，对方自称“回收商”，并按重量收购。也就是说，这批物资可能在中转环节被当作废旧品处理。",
          "捐赠活动的主办方表示已介入核查。我们在报道中隐去了具体小区与卖家信息，仅保留与流程相关的事实。",
        ],
      },
      {
        heading: "捐赠前可以做的两件事",
        paragraphs: [
          "一是问清楚物资的接收主体与去向；二是保留捐赠凭证。这两点看起来琐碎，却是把善意落到实处的关键。",
        ],
      },
    ],
  },
  {
    id: "rural-delivery-second-fee",
    title: "乡镇快递二次收费：一笔每次两元的“代收费”",
    category: "民生身边事",
    categorySlug: "livelihood",
    summary:
      "包裹到了镇上，取件还要再付两元。代收点说“这是上门的成本”，快递公司说“从没授权”。",
    author: "直曝编辑部",
    date: "2026-06-28",
    readTime: "5 分钟",
    views: 2910,
    tags: ["快递", "乡镇", "乱收费"],
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20image%20of%20a%20small%20town%20parcel%20pickup%20shelf%20filled%20with%20plain%20packages%2C%20warm%20afternoon%20light%2C%20muted%20cream%20and%20soft%20red%20tones%2C%20minimal%20documentary%20composition%2C%20no%20readable%20text%2C%20subtle%20grain%2C%20high%20detail&width=800&height=560&seq=lead-rural-delivery-09&orientation=landscape",
    content: [
      {
        heading: "两元钱的来历",
        paragraphs: [
          "在部分乡镇，快递通常只送到镇上的代收点，取件时按件收取一到三元不等的“代收费”。",
          "投稿人提供了近半年的取件记录，累计支付了两百余元。他问代收点要依据，对方回答“大家都这么收”。",
        ],
      },
      {
        heading: "谁在收费",
        paragraphs: [
          "我们以普通用户身份咨询了对应的快递公司客服，得到的答复是“未授权任何末端网点额外收费”，并建议走官方投诉渠道。",
          "问题的症结在于，末端网点的生存成本与快递总部的结算标准之间，长期存在缺口，这个缺口最后落到了取件人身上。",
        ],
      },
      {
        heading: "如果你也遇到",
        paragraphs: [
          "保留收费凭证与取件时间，先向快递公司官方渠道反映，再通过我们的投稿通道留下记录，人多的时候，问题才会被真正看见。",
        ],
      },
    ],
  },
];